import usePrivateAxios from '@/common/api/usePrivateAxios'
import { UpdateContractBillDetailsSchema } from '@/features/privateCompanies/schemas/contract/updateBillDetails.schema'
import { useMutation } from '@tanstack/react-query'

interface UseUpdateContractBillDetails {
  contractId?: string
  onSuccess?: (response: any) => void
  onError?: (error: any) => void
}

export const useUpdateContractBillDetails = ({ contractId, onSuccess, onError }: UseUpdateContractBillDetails) => {
  const privateAxios = usePrivateAxios()

  return useMutation({
    mutationKey: ['updateContractBillDetails'],
    mutationFn: async (data: UpdateContractBillDetailsSchema) => {
      const contract = {
        cycle: data.contract?.cycle?.value || undefined,
        cycle_start_day: data.contract?.cycle_start_day?.value || undefined,
        cycle_fixed_interval: data.contract?.cycle?.value === 'fixed' && data.contract?.cycle_fixed_interval || undefined,
        closing_to_due_in_days: data.contract?.closing_to_due_in_days?.value || undefined,
        bill_grouping_mode: data.contract?.bill_grouping_mode?.value || undefined,
        bill_sub_grouping_mode: data.contract?.bill_sub_grouping_mode?.value || undefined,
        bill_by: data.contract?.bill_by?.value || undefined,
        payment_method: data.contract?.payment_method?.value || undefined,
        due_to_suspension_in_days: data.contract?.due_to_suspension_in_days?.value || undefined,
        cnpj_for_fiscal_document: data.contract?.cnpj_for_fiscal_document?.value || undefined,
      }

      await privateAxios.put(`/client/contracts/${contractId}/update_contract_bill_information`, {
        contract,
      })
    },
    onSuccess,
    onError,
  })
}
